import { render, staticRenderFns } from "./SurveyCardHeader.vue?vue&type=template&id=6f5e123c&scoped=true"
import script from "./SurveyCardHeader.vue?vue&type=script&lang=js"
export * from "./SurveyCardHeader.vue?vue&type=script&lang=js"
import style0 from "./SurveyCardHeader.vue?vue&type=style&index=0&id=6f5e123c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5e123c",
  null
  
)

export default component.exports